@if (isOpen()) {
  <div class="modal d-block" (click)="close()">
    <div class="modal-fullscreen" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title() }}</h5>
          <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <ng-content></ng-content>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop show"></div>
}